<h2>Neuer Zugang</h2>

<p>Sie haben einen Einladungslink erhalten?</p>
<p>Öffnen Sie den Einladungslink in diesem Browser-Fenster erneut.</p>

<div class="hr">
  <span>oder</span>
</div>

<p>Sie haben einen Einladungscode per Post oder auf Ihrer Rechnung erhalten?</p>
<p>Aktivieren Sie Ihren Zugang mit Ihrer Kundennummer und dem Einladungscode, den sie per Post / mit Ihrer Rechnung erhalten haben.</p>

<form id="invitationForm" (ngSubmit)="submit()">
  <p>
    <mat-form-field color="accent">
      <input matInput type="text" name="custId" placeholder="Kundennummer" [formControl]="custIdFormControl"
             required/>
      <mat-error *ngIf="custIdFormControl.hasError('required')">
        Die Kundennummer ist erforderlich.
      </mat-error>
    </mat-form-field>
    <mat-form-field color="accent">
      <input matInput type="text" name="icode" placeholder="Einladungs-Code" [formControl]="icodeFormControl"
             required/>
      <mat-error *ngIf="icodeFormControl.hasError('required')">
        Bitte geben Sie einen Einladungs-Code ein.
      </mat-error>
      <mat-error *ngIf="icodeFormControl.hasError('not_found')">
        Der Einladungs-Code ist ungültig.
      </mat-error>
      <mat-error *ngIf="icodeFormControl.hasError('conflict')">
        Der Einladungs-Code wird bereits verwendet.
      </mat-error>
    </mat-form-field>
  </p>
  <p>
    <button mat-stroked-button color="accent" [matDialogClose] class="left">Schließen</button>
    <button mat-flat-button color="accent" class="right" type="submit">Einladungs-Code einlösen</button>
  </p>
</form>

